import { Box, BoxProps, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

type StyledPreviewRectanglePropsType = BoxProps & {
  width: number;
  height: number;
};

const StyledPreviewRectangle = styled(Box, {
  shouldForwardProp: (prop) => prop !== "width" && prop !== "height",
})<StyledPreviewRectanglePropsType>(({ theme, width, height }) => ({
  position: "relative",
  objectFit: "contain",
  maxWidth: "100%",
  maxHeight: "100%",
  aspectRatio: `${width / height}`,
  margin: "auto",
  flex: 1,
  transition: "all 0.3s",
  border: `solid 2px ${theme.palette.secondary[3]}`,
  borderRadius: "10px",
}));

const StyledPreviewAnchor = styled("div")({
  position: "absolute",
  width: "18px",
  height: "18px",
});

const StyledPreviewTopLeftAnchor = styled(StyledPreviewAnchor)(({ theme }) => ({
  top: 8,
  left: 8,
  borderTopLeftRadius: "6px",
  borderLeft: `solid 2px ${theme.palette.secondary[3]}`,
  borderTop: `solid 2px ${theme.palette.secondary[3]}`,
}));

const StyledPreviewBottomRightAnchor = styled(StyledPreviewAnchor)(
  ({ theme }) => ({
    bottom: 8,
    right: 8,
    borderBottomRightRadius: "6px",
    borderBottom: `solid 2px ${theme.palette.secondary[3]}`,
    borderRight: `solid 2px ${theme.palette.secondary[3]}`,
  }),
);

const StyledRootContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8),
  backgroundColor: theme.palette.secondary[8],
  borderBottom: `solid 1px ${theme.palette.secondary[6]}`,
}));

const StyledPreviewContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.secondary[8],
  aspectRatio: 1,
}));

const StyledRectangleContainer = styled(Box)({
  position: "relative",
  height: "100%",
  display: "flex",
});

const StyledTextContainer = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  textAlign: "center",
});

type DimensionsPreviewProps = {
  dimensions: [number, number];
};

export const DimensionsPreview = (props: DimensionsPreviewProps) => {
  const { dimensions } = props;

  const [width, height] = dimensions;

  return (
    <StyledRootContainer>
      <StyledPreviewContainer>
        <StyledRectangleContainer
          sx={{
            flexDirection: width > height ? "row" : "column",
          }}
        >
          <StyledPreviewRectangle width={width} height={height}>
            <StyledPreviewTopLeftAnchor />
            <StyledPreviewBottomRightAnchor />
            <StyledTextContainer>
              <Typography
                variant="small"
                color="secondary.2"
                sx={{
                  letterSpacing: "0.05em",
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              >
                {`${width} x ${height}`}
              </Typography>
            </StyledTextContainer>
          </StyledPreviewRectangle>
        </StyledRectangleContainer>
      </StyledPreviewContainer>
    </StyledRootContainer>
  );
};
